import { ModesEnum } from "@/types/kassa";
import createConfig from "@/utils/createConfig";

//

const config = {
  mongoUrl: process.env.MONGO_URL,
  prevMongodbUrl: process.env.PREV_MONGO_URL,
  dbCacheSec: 60 * 60,
  kaspiDeliveryCosts: {
    CHEAPER_5000: {
      city: 0,
      country: 0,
    },
    CHEAPER_15000: {
      city: 549,
      country: 699,
    },
    LIGHTER_5: {
      city: 649,
      country: 1099,
    },
    LIGHTER_15: {
      city: 899,
      country: 1499,
    },
    LIGHTER_50: {
      city: 2199,
      country: 2699,
    },
    HEAVIER_50: {
      city: 3199,
      country: 3999,
    },
  },
  kaspiMinPrice: 10,
  nds: 0.12,
  telegramBotToken: process.env.TELEGRAM_BOT_TOKEN,
  telegramAsemGroupId: -4137828716,
  telegramBotUsername: "SELLPRO_TGBOT",
  reKassa: {
    mode: "ACTIVE" satisfies ModesEnum,
    TEST: { apiKey: process.env.REKASSA_TEST },
    ACTIVE: { apiKey: process.env.REKASSA_ACTIVE },
  },
  me: {
    googlesheetsid: process.env.GOOGLE_SHEETS_ID,
    username: process.env.USERNAME,
    merchantId: process.env.MERCHANT_ID,
    telegaChatId: Number(process.env.TELEGA_CHAT_ID),
    orgId: process.env.ORG_ID,
    organizationId: process.env.ORGANIZATION_ID,
    kaspiCabinetId: process.env.KASPI_CABINET_ID,
    phone: Number(process.env.PHONE),
    email: process.env.EMAIL,
    password: process.env.PASSWORD,
  },
  kaspiAuth: {
    username: process.env.KASPI_AUTH_USERNAME,
    password: process.env.KASPI_AUTH_PASSWORD,
  },
  cloudinary: {
    cloudName: process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME,
    apiKey: process.env.CLOUDINARY_API_KEY,
    apiSecret: process.env.CLOUDINARY_API_SECRET,
  },
  tiptoppay: {
    concurrency: 30,
  },

  DEVELOPMENT_CLERK_ORG_ID: null as null | string,
};

//

export default createConfig(config, {
  telegramBotToken: process.env.TELEGRAM_BOT_TOKEN_DEV,
  telegramBotUsername: "SELLPRO_DEV_TGBOT",
  tiptoppay: {
    concurrency: 5,
  },
  DEVELOPMENT_CLERK_ORG_ID: null, // "org_2xvIEBJkQVccG86tywN53rO0Kz5", //"org_2pET1d2oW62unztwyuct5URtec1",
});
